import { toObjectMap } from "@@/utilities/dictionary";
import { z } from "zod";

const hzPlacements = ["right", "left"] as const;
const vtPlacements = ["above", "below"] as const;
const placements = [...hzPlacements, ...vtPlacements] as const;

type HzPlacement = (typeof hzPlacements)[number];
type VtPlacement = (typeof vtPlacements)[number];
type Placement = HzPlacement | VtPlacement;

const hzPlacement = toObjectMap<HzPlacement>([...hzPlacements]);
const vtPlacement = toObjectMap<VtPlacement>([...vtPlacements]);
const placement = toObjectMap<Placement>([...placements]);

const hzPlacementZodSchema = z.enum(hzPlacements);
const vtPlacementZodSchema = z.enum(vtPlacements);
const placementZodSchema = z.union([
    hzPlacementZodSchema,
    vtPlacementZodSchema,
]);

export {
    hzPlacement,
    hzPlacements,
    hzPlacementZodSchema,
    placement,
    placements,
    placementZodSchema,
    vtPlacement,
    vtPlacements,
    vtPlacementZodSchema,
};
export type { HzPlacement, Placement, VtPlacement };
